.pageContent {
  flex: 1;
  display: flex;
  flex-direction: column;
  min-width: 0;
  min-height: 100vh;
  height: 100vh;
  padding: 2rem;
  box-sizing: border-box;
}

.topBarContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 20px;
}

.shipmentNameContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.shipmentSubTextContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
}

.shipmentId {
  color: var(--static-text-weak);
}

.shipmentIdLoader {
  background: var(--static-text-weak);
  height: 18px;
  width: 200px;
  border-radius: 20px;
}

.shipmentName {
  font-size: var(--fs-small-heading);
  color: var(--static-text-strong);
}

.shipmentNameLoader {
  background: var(--static-text-weak);
  height: 36px;
  width: 300px;
  border-radius: 20px;
  margin-bottom: 6px;
}

.labelButtonsContainer {
  display: flex;
  align-items: center;
  justify-content: space-between;
}

.buttonSpacing {
  margin-left: 15px;
}

.externalShipmentNotice {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  width: 100%;
  border-radius: 12px;
  padding: 16px;
  box-sizing: border-box;
  background: rgba(133, 133, 133, 0.20);
  margin-bottom: 20px;
}

.noticeText {
  margin-left: 16px
}

.shipmentDetailsContainer {
  display: flex;
  box-sizing: border-box;
  justify-content: space-between;
  align-items: flex-start;
}

.productDetailsColumn {
  
}

.productDetailsContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  background: var(--static-background-standard);
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.75rem;
  width: 100%;
  margin-right: 10px;
  overflow: hidden;
}

.productDetailsHeaderContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 1.25rem;
  box-sizing: border-box;
  width: 100%;
}

.productDetailsHeader {
  display: flex;
  justify-content: flex-start;
  align-items: center;
}

.productDetailsHeaderText {
  color: var(--static-text-strong);
  margin-left: 10px;
}

.numOfShips {
  margin-left: 5px;
}

.productDetailsControls {
  transition: 0.3s ease-in-out;
  transform: rotate(0deg);
}

.productDetailsControlsOpen {
  transition: 0.3s ease-in-out;
  transform: rotate(180deg);
}

.productDetailsItemsContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  background: var(--static-background-standard);
  width: 100%;
  height: 0px;
  overflow: hidden;
}

.productDetailsItemsContainerOpen {
  height: fit-content;
}

.productDetailsItemContainer {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  border-top: 1px solid var(--static-divider-standard);
  padding: 1.25rem;
  width: 100%;
}

.productDetailsLeftColContainer {
  display: flex;
  justify-content: center;
  align-items: center;
  flex-direction: column;
  margin-right: 20px;
}

.productDetailsImageContainer {
  border: 2px solid var(--static-divider-standard);
  border-radius: 0.75rem;
  overflow: hidden;
  height: 84px;
  width: 84px;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 0.25rem;
  background-color: var(--static-background-standard);
}

.productDetailsImage {
  height: 100%;
  border-radius: 8px;
}

.shipmentItemQuantity {
  font-size: var(--fs-small);
  color: var(--static-text-standard);
}

.productName {
  color: var(--static-text-strong);
  line-height: 18px;
  margin-bottom: 10px;
}

.productSubInfo {
  color: var(--static-text-weak);
  font-size: var(--fs-small);
}

.productSubInfoStandardText {
  color: var(--static-text-standard);
}

.productDetailsRightColContainer {
  margin-top: 5px;
}

.bolSpinner::before, .bolSpinner::after {
  border-color: white;
}

.shippingDetails {
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  margin-left: 10px;
}

.shipmentStatusContainer {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  box-sizing: border-box;
  padding: 16px 24px;
  background: var(--static-background-standard);
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.75rem;
  width: 100%;
  margin-bottom: 20px;
}

.iconContainer {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 7px;
  border-radius: 100%;
  box-sizing: border-box;
  border: 1px solid var(--static-divider-standard);
}

.shipmentStatusTextContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 15px;
}

.shipmentStatusLabel {
  color: var(--static-text-strong);
}

.shipmentStatusText {
  color: var(--static-text-strong);
  margin-top: 5px;
}

.statusTextLoader {
  background: var(--static-text-weak);
  height: 21px;
  width: 100px;
  border-radius: 10px;
}

.shipmentHistoryContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  padding: 16px 24px;
  background: var(--static-background-standard);
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.75rem;
  width: 100%;
  margin-bottom: 20px;
}

.shipmentHistoryLabel {
  font-size: 20px;
  color: var(--static-text-strong);
  margin-bottom: 20px;
}

.historySectionContainer {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
}

.historySectionContainerSpacing {
  margin-bottom: 30px;
}

.historySectionContainerSpacingSmall {
  margin-bottom: 10px;
}

.historyTextContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 15px;
}

.historyLabel {
  color: var(--static-text-strong);
}

.historyText {
  color: var(--static-text-weak);
}

.historyTrack {
  position: absolute;
  left: -3px;
  bottom: -23px;
  transform: rotate(90deg);
  border-bottom: 3px dotted var(--static-divider-standard);
  width: 36px;
}

.shippingDetailsContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  background: var(--static-background-standard);
  border: 1px solid var(--static-divider-standard);
  border-radius: 0.75rem;
  padding: 16px 24px;
  width: 100%;
  margin-bottom: 20px;
}

.shippingDetailsLabel {
  font-size: 1.25rem;
  color: var(--static-text-strong);
  margin-bottom: 20px;
  box-sizing: border-box;
}

.shippingDetailsSectionContainer {
  display: flex;
  justify-content: flex-start;
  align-items: flex-start;
  box-sizing: border-box;
}

.shippingDetailsSectionContainerSpacing {
  margin-bottom: 25px;
}

.shippingDetailsSectionContainerSpacingSmall {
  margin-bottom: 10px;
}

.shippingDetailsTextContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  margin-left: 15px;
}

.shippingLabel {
  color: var(--static-text-weak);
}

.shippingText {
  color: var(--static-text-strong);
  font-size: var(--fs-small-heading);
}

.shippingAddressText {
  color: var(--static-text-weak);
}

.shippingDetailsTrack {
  position: absolute;
  left: -11px;
  bottom: -36px;
  transform: rotate(90deg);
  border-bottom: 3px dotted var(--static-divider-standard);
  width: 61px;
}

.shippingIconContainer {
  position: relative;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 100%;
  box-sizing: border-box;
  border: 1px solid var(--static-divider-standard);
}

.shippingTextLoader {
  background: var(--static-text-weak);
  height: 22px;
  width: 150px;
  border-radius: 20px;
  margin-bottom: 5px;
}

.shippingAddressLoader {
  background: var(--static-text-weak);
  height: 21px;
  width: 220px;
  border-radius: 10px;
}

.shipmentContentsLabel {
  color: var(--static-text-strong);
  margin-bottom: 20px;
  margin-top: 16px;
  box-sizing: border-box;
}

.shipmentContentsContainer {
  display: flex;
  justify-content: center;
  align-items: flex-start;
  flex-direction: column;
  box-sizing: border-box;
  border-top: 1px solid var(--static-divider-standard);
  box-sizing: border-box;
  width: 100%;
  margin-top: 20px;
}

.shippingContentContainer {
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 10px;
  width: 100%;
}

.shippingContentLabel {
  color: var(--static-text-weak);
}

.shippingContentValueSpacing {
  margin-top: 16px;
  margin-bottom: 0px;
}

.shippingContentValue {
  color: var(--static-text-strong);
}

.estimatedShippingCharge {
  color: var(--static-text-strong);
}

.shippingContentValueLoader {
  background: var(--static-text-weak);
  height: 9px;
  width: 100px;
  border-radius: 10px;
}
